import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SamlRequest } from '../model/samltoken';

@Injectable({
  providedIn: 'root'
})
export class ClaveService {

  constructor(private http: HttpClient) { }

  API_URL: string = environment.API_URL;

  getSamlRequest(): Observable<SamlRequest>{
    let API_URL = `${this.API_URL}/clave/login`;
    return this.http.get<SamlRequest>(API_URL);
  }
  iniciaFirma(id:any, tipo:any): Observable<SamlRequest>{
    let API_URL = `${this.API_URL}/clave/iniciaFirma/${id}/${tipo}`;
    return this.http.get<SamlRequest>(API_URL);
  }
  getResultFirma(responseToId:any): Observable<SamlRequest>{
    let API_URL = `${this.API_URL}/clave/getResultFirma/${responseToId}`;
    return this.http.get<SamlRequest>(API_URL);
  }
}
